import styled from 'styled-components';

export const GrantList = styled.div`
  color: ${(p) => p.theme.textColor};
  font-weight: bold;
  margin-bottom: 20px;
`;
